module.exports = __webpack_public_path__ + "img/banner_450x2.db5e0bb2.webp";